import { useState } from 'react'

export const useCheckbox = (initialSelected: boolean, onChange: () => void) => {
  const [isSelected, setIsSelected] = useState(initialSelected)

  const toggleCheckbox = () => {
    setIsSelected(!isSelected)
    onChange()
  }

  return {
    isSelected,
    toggleCheckbox,
    setIsSelected
  }
}
